class QuantityBundle {
  constructor(container) {
    this.container = container;
    this.radioInputs = container.querySelectorAll('.quantity-bundle-radio');
    this.productElements = container.querySelectorAll('.quantity-bundle-product');
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.initializeSelection();
    this.interceptProductForm();
    this.alignTagsHeight();
  }
  
  bindEvents() {
    this.radioInputs.forEach(radio => {
      radio.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.updateSelection(e.target);
          this.replaceProductInForm(e.target);
        }
      });
    });
  }
  
  updateSelection(selectedRadio) {
    this.productElements.forEach(product => {
      product.classList.remove('selected');
    });
    
    const selectedProduct = selectedRadio.closest('.quantity-bundle-product');
    if (selectedProduct) {
      selectedProduct.classList.add('selected');
    }
  }
  
  initializeSelection() {
    const checkedRadio = this.container.querySelector('.quantity-bundle-radio:checked');
    const firstRadio = this.radioInputs[0];
    
    if (checkedRadio) {
      this.updateSelection(checkedRadio);
      setTimeout(() => this.replaceProductInForm(checkedRadio), 100);
    } else if (firstRadio) {
      firstRadio.checked = true;
      this.updateSelection(firstRadio);
      setTimeout(() => this.replaceProductInForm(firstRadio), 100);
    }
  }
  
  getSelectedValue() {
    const checkedRadio = this.container.querySelector('.quantity-bundle-radio:checked');
    return checkedRadio ? checkedRadio.value : null;
  }
  
  setSelection(value) {
    const targetRadio = this.container.querySelector(`.quantity-bundle-radio[value="${value}"]`);
    if (targetRadio) {
      targetRadio.checked = true;
      this.updateSelection(targetRadio);
      this.replaceProductInForm(targetRadio);
    }
  }

  replaceProductInForm(selectedRadio) {
    const selectedProduct = selectedRadio.closest('.quantity-bundle-product');
    
    if (!selectedProduct) return;

    const variantId = selectedProduct.dataset.variantId;
    const productTitle = selectedProduct.dataset.productTitle;
    const optionValue = selectedRadio.value;

    if (!variantId) return;

    setTimeout(() => {
      this.findAndUpdateProductForm(variantId, productTitle, optionValue);
    }, 50);
  }

  findAndUpdateProductForm(variantId, productTitle, optionValue) {
    const mainForm = document.querySelector('form.form.product-purchase-form:not(.hidden)');
    
    let actualForm = mainForm;
    if (!actualForm) {
      const buyButton = document.querySelector('button[type="submit"][data-btn-type="add-to-cart"]');
      if (buyButton) {
        actualForm = buyButton.closest('form');
      }
    }

    if (actualForm && actualForm.tagName === 'FORM') {
      this.updateFormVariant(actualForm, variantId, productTitle, optionValue, 'principal');
    } else {
      const allForms = document.querySelectorAll('form');
      allForms.forEach(form => {
        const variantInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
        if (variantInput && !form.id.includes('installments')) {
          this.updateFormVariant(form, variantId, productTitle, optionValue, 'alternativo');
        }
      });
    }
  }

  updateFormVariant(form, variantId, productTitle, optionValue, formType) {
    const variantInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
    
    if (variantInput) {
      variantInput.value = variantId;

      let isExternalProduct = false;
      
      if (variantInput.tagName === 'SELECT') {
        const option = variantInput.querySelector(`option[value="${variantId}"]`);
        if (option) {
          option.selected = true;
        } else {
          isExternalProduct = true;
        }
      }

      if (!isExternalProduct) {
        const changeEvent = new Event('change', { bubbles: true });
        variantInput.dispatchEvent(changeEvent);
      }

      if (isExternalProduct) {
        this.ensureRequiredFields(form, variantId);
      }

      this.dispatchVariantUpdatedEvent(variantId, productTitle);
      this.dispatchProductChangeEvent(variantId, productTitle, optionValue);
    }
  }

  dispatchVariantUpdatedEvent(variantId, productTitle) {
    this.updateProductDisplay(variantId, productTitle);
  }

  updateProductDisplay(variantId, productTitle) {
    const addButton = document.querySelector('button[type="submit"][data-btn-type="add-to-cart"]');
    if (addButton) {
      addButton.classList.remove('disabled', 'unavailable');
      addButton.disabled = false;
      
      const buttonText = addButton.querySelector('.button-text');
      if (buttonText) {
        buttonText.textContent = 'Comprar';
      }
    }
  }

  getProductData() {
    const productDataScript = document.querySelector('script[type="application/json"][data-product-json]');
    if (productDataScript) {
      try {
        return JSON.parse(productDataScript.textContent);
      } catch (e) {
        return null;
      }
    }
    
    if (window.productData) {
      return window.productData;
    }
    
    if (window.product) {
      return window.product;
    }
    
    return null;
  }

  dispatchProductChangeEvent(variantId, productTitle, optionValue) {
    const event = new CustomEvent('quantityBundleProductChanged', {
      detail: {
        variantId: variantId,
        productTitle: productTitle,
        optionValue: optionValue,
        timestamp: Date.now()
      }
    });

    document.dispatchEvent(event);
  }

  interceptProductForm() {
    setTimeout(() => {
      const mainForm = document.querySelector('form.form.product-purchase-form:not(.hidden)');
      
      let actualForm = mainForm;
      if (!actualForm) {
        const buyButton = document.querySelector('button[type="submit"][data-btn-type="add-to-cart"]');
        if (buyButton) {
          actualForm = buyButton.closest('form');
        }
      }
      
      const productForms = [];
      
      if (actualForm && actualForm.tagName === 'FORM') {
        const variantInput = actualForm.querySelector('input[name="id"]') || actualForm.querySelector('select[name="id"]');
        if (variantInput) {
          productForms.push({
            form: actualForm,
            variantInput: variantInput,
            type: 'principal'
          });
        }
      }

      if (productForms.length === 0) return;

      productForms.forEach(({ form, variantInput, type }) => {
        let lastValue = variantInput.value;
        
        const observer = new MutationObserver(() => {
          if (variantInput.value !== lastValue) {
            lastValue = variantInput.value;
          }
        });
        
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      });
    }, 100);
  }

  getSelectedProductData() {
    const selectedRadio = this.container.querySelector('.quantity-bundle-radio:checked');
    
    if (!selectedRadio) return null;

    const selectedProduct = selectedRadio.closest('.quantity-bundle-product');
    
    if (!selectedProduct) return null;

    return {
      variantId: selectedProduct.dataset.variantId,
      productId: selectedProduct.dataset.productId,
      productHandle: selectedProduct.dataset.productHandle,
      productTitle: selectedProduct.dataset.productTitle,
      optionValue: selectedRadio.value
    };
  }

  replaceVariantInForm(form, newVariantId) {
    const variantInput = form.querySelector('input[name="id"]');
    
    if (variantInput) {
      variantInput.value = newVariantId;
    }
  }

  ensureRequiredFields(form, variantId) {
    const existingVariantInput = form.querySelector('input[name="id"]');
    
    if (!existingVariantInput) {
      const variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.name = 'id';
      variantInput.value = variantId;
      form.appendChild(variantInput);
    } else {
      existingVariantInput.value = variantId;
    }

    if (!form.method || form.method.toLowerCase() !== 'post') {
      form.method = 'POST';
    }

    if (!form.action || form.action === '') {
      form.action = '/cart/add';
    }

    const requiredFields = ['quantity'];
    requiredFields.forEach(fieldName => {
      const existingField = form.querySelector(`input[name="${fieldName}"]`);
      if (!existingField) {
        const field = document.createElement('input');
        field.type = 'hidden';
        field.name = fieldName;
        field.value = '1';
        form.appendChild(field);
      }
    });
  }

  alignTagsHeight() {
    setTimeout(() => {
      const tagWrappers = this.container.querySelectorAll('.quantity-bundle-tags-wrapper');
      
      if (tagWrappers.length === 0) return;

      // Remove altura fixa anterior
      tagWrappers.forEach(wrapper => {
        wrapper.style.minHeight = '';
      });

      // Calcula altura máxima necessária
      let maxHeight = 0;
      tagWrappers.forEach(wrapper => {
        const height = wrapper.scrollHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Aplica altura máxima a todos os wrappers
      if (maxHeight > 0) {
        tagWrappers.forEach(wrapper => {
          wrapper.style.minHeight = `${maxHeight}px`;
        });
      }
    }, 100);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const bundleContainers = document.querySelectorAll('[data-quantity-bundle]');
  
  bundleContainers.forEach(container => {
    if (!container.quantityBundle) {
      container.quantityBundle = new QuantityBundle(container);
    }
  });
});

window.QuantityBundle = QuantityBundle;

